import gql from "graphql-tag";
const run = gql`fragment MonitorRun on InventoryMonitorRun {
  _id status sourceMode masterSnapshotAt message createdAt startedAt finishedAt updatedAt total checked critical warning review affected verified unknown
  categories { code label count }
}`;
export const overviewQuery = gql`query InventoryMonitorOverview($shopId: ID!) {
  inventoryMonitorOverview(shopId: $shopId) {
    checkedAt latest { ...MonitorRun } active { ...MonitorRun } history { ...MonitorRun }
    masterMode operationalStatus jobs { type status count } interfaceErrorsLastHour lastInterfaceEvent testMode
  }
} ${run}`;
export const startMutation = gql`mutation StartInventoryMonitorScan($shopId: ID!) {
  startInventoryMonitorScan(shopId: $shopId) { ...MonitorRun }
} ${run}`;
export const rowsQuery = gql`query InventoryMonitorRows($input: InventoryMonitorRowsInput!) {
  inventoryMonitorRows(input: $input) { totalCount nodes {
    _id variantId productId productNumber serialNumber title vendor storage limesId inventoryInStock inventoryReserved availableToSell
    expectedReserved masterInventoryInStock masterVerified severity issues { code severity label detail action }
  } }
}`;
